import React, { useState } from 'react';
import { get } from 'lodash';
import axios from 'axios';
import CursorBasedList from '../CursorBasedList';

const EMPLTransactions = ({
  bagId,
  expiring
}) => {
  const endpoint = `/${gon.currentProvider}/api/bags/${bagId}/empl_transactions?expiring=${expiring}`

  const fetchData = (endpoint) => {
    return (cursor, callback) => {
      axios.get(
        endpoint, { params: { cursor: cursor } }
      ).then((res) => {
        const data = get(res, 'data')
        if (res.status == 200 && data) {
          callback(data.transactions || [], data.cursor)
        }
      })
    }
  }

  const renderItems = (items) => items.map((transaction) => (
    <div key={transaction.id} className='Table__row'>
      <div className='Table__col'>{transaction.id}</div>
      <div className='Table__col'>{transaction.source_type}</div>
      <div className='Table__col'>{transaction.locked_amount.toLocaleString()}</div>
      <div className='Table__col'>{transaction.unlocked_amount.toLocaleString()}</div>
      <div className='Table__col'>{transaction.occurred_at}</div>
      <div className='Table__col'>
        {get(transaction, 'details.yay_transaction_code') && `yay_transaction_code: ${get(transaction, 'details.yay_transaction_code')}`}
        {get(transaction, 'details.transaction_code') && `transaction_code: ${get(transaction, 'details.transaction_code')}`}
      </div>
    </div>
  ))

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3 User__header__upper-space'>{ expiring && 'Expiring ' }EMPL Transactions</h3>
      </div>

      <CursorBasedList
        fetchData={fetchData(endpoint)}
        renderItems={renderItems}
        tableClass='Table Table--empl-transactions'
      >
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>Id</div>
          <div className='Table__col Table__col--th'>Type</div>
          <div className='Table__col Table__col--th'>Locked amount</div>
          <div className='Table__col Table__col--th'>Unlocked amount</div>
          <div className='Table__col Table__col--th'>Occurred at</div>
          <div className='Table__col Table__col--th'>Details</div>
        </div>
      </CursorBasedList>
    </React.Fragment>
  )
}

export default EMPLTransactions
